import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';

import FlashCardPage from '../../../subsreens/gcstudent/flashcardpage/FlashCardPage';

const FlashCard = () => {
    return(
        <StudentDashboardLayout>
            <FlashCardPage></FlashCardPage>
        </StudentDashboardLayout>
    )
}

export default  FlashCard;